"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPES = exports.INITIAL_VISIBLE_COLUMNS = exports.columns = void 0;
exports.columns = [
    { uid: "title", name: "Title", sortable: true },
    { uid: "type", name: "Type", sortable: true },
    { uid: "minimum_quantity", name: "Minimum Quantity", sortable: true },
    { uid: "maximum_quantity", name: "Maximum Quantity", sortable: true },
    { uid: "actions", name: "Actions", sortable: false },
];
exports.INITIAL_VISIBLE_COLUMNS = ["title", "type", "minimum_quantity", "maximum_quantity", "actions"];
exports.TYPES = [
    { label: "Add on", value: "ADD ON" },
    { label: "Wrap type", value: "WRAP TYPE" },
];
